import { useTranslation } from 'react-i18next';
import { UserService } from '../services/User.service';
import { makeListQueryKey } from './utils/user';
import { useMutation } from '@shared/lib/hooks';
import { ToastService } from '@shared/lib/services/toast.service';
export function useRemoveUser() {
    const projectId = process.env.CUSTOMER_PROJECT_ID;
    const { t } = useTranslation();
    const listQueryOptions = { queryKey: makeListQueryKey(projectId) };
    const { mutate: removeUser, isLoading: isRemoving, isSuccess: isRemoved } = useMutation({
        mutationFn: (userId) => UserService.removeUser(projectId, userId).catch(() => {
            const errorMessage = t('Error occurred. Please try to delete again.');
            ToastService.error(errorMessage);
            throw new Error(errorMessage);
        }),
        options: listQueryOptions
    });
    return {
        removeUser,
        isRemoving,
        isRemoved
    };
}
